import axios from 'axios';
import { CLIENT_SEARCH_URL, toSearchBody } from 'utils/clientSearch';

export const authService = {
    /** Tags */

    getTagsService: (params) => axios.get(`/tags`, { auth: true, params: { ...params } }),

    createTagService: (body) => axios.post(`/tags`, body, { auth: true }),

    editTagService: (body) => axios.patch(`/tags/${body?._id || body?.id}`, body, { auth: true }),

    deleteTagService: (id) => axios.delete(`/tags/${id}`, { auth: true }),

    /** End */

    /** Tag for members */

    addTagToMemberService: (id, body) => axios.post(`/tags/assign/${id}`, body, { auth: true }),

    /** End */

    getAdminsService: (data) => axios.get('/staff', { auth: true, params: { ...data } }),

    getAdminByIdService: (id) => axios.get(`/staff/${id}`, { auth: true }),

    getClientsService: (data) => axios.post(CLIENT_SEARCH_URL, toSearchBody(data), { auth: true }),

    getClientByIdService: (id) => axios.get(`/client/${id}`, { auth: true }),

    getResourceService: (data) => axios.get('/resource', { auth: true, params: { ...data } }),

    getResourceByIdService: (id) => axios.get(`/resource/${id}`, { auth: true }),

    getInvoiceByIdService: (id) => axios.get(`/invoice/${id}`, { auth: true }),

    getGoalService: (data) => axios.get(`/clinical/goals`, { auth: true, params: { ...data } }),

    getGoalByIdService: (id) => axios.get(`/clinical/goals/${id}`, { auth: true }),

    getLibraryGoalsService: (data) => axios.get(`/clinical/library/goals`, { auth: true, params: { ...data } }),

    getLibraryGoalByIdService: (id) => axios.get(`/clinical/library/goals/${id}`, { auth: true }),

    getTasksService: (params) => axios.get('/task', { auth: true, params: { ...params } }),

    getInvoicesService: (data) => axios.get('/invoice', { auth: true, params: { ...data } }),
};
